import * as bootstrap from 'bootstrap';
import { pannellum } from './pannellum';

// Define the interface of a scene.
interface Scene {
  type: 'equirectangular';
  hotSpotDebug?: boolean; // This should only be used in development for finding the correct yaw and pitch.
  panorama: URL;
  hotSpots: Hotspot[];
  autoLoad: true;
}
// Define the interface of a hotspot.
interface Hotspot {
  type: 'info' | 'scene';
  id: string;
  pitch: number;
  yaw: number;
  text: string;
  cssClass: string;
  clickHandlerFunc: Function;
  clickHandlerArgs: {
    afterCompletion?: {
      create?: string;
      view?: string;
      hide?: boolean;
    };
    startingAction?: number; // Only if there is an action to start with.
    id: string;
  };
  sceneId?: string; // Only when it's a scene hotspot.
}

// Creating the action interface, an action can be of three types: text, video or question.
interface Action {
  type: 'text' | 'video' | 'question' | 'redirect';
  next?: number;
}

// Creating the text action interface.
interface TextAction extends Action {
  type: 'text';
  content: string;
  img?: string;
}

// Creating the video action interface.
interface VideoAction extends Action {
  type: 'video';
  vimeoId: number;
}

// Creating the question action interface.
interface QuestionAction extends Action {
  type: 'question';
  question: string;
  answers: {
    answer: string;
    next?: number;
  }[];
}

// Creating the redirect action interface.
interface RedirectAction extends Action {
  type: 'redirect';
  url: string;
}
const startingScene = 'Ruimte_1';const scenes : { [sceneName: string]: Scene } = {"Ruimte_1":{"type":"equirectangular","panorama":new URL('../Assets/360/Ruimte_1.jpg',import.meta.url),"hotSpots":[{"id":"Ruimte_1_1","cssClass":"custom-hotspot Ruimte_1_1","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_1","afterCompletion":{"create":"Ruimte_1_2","view":"Ruimte_1_2","hide":true},"startingAction":0},"pitch":170,"yaw":170,"type":"info","text":"Werken bij Rijksmuseum"}],"autoLoad":true},"Ruimte_2":{"type":"equirectangular","panorama":new URL('../Assets/360/Ruimte_2.jpg',import.meta.url),"hotSpots":[{"id":"Ruimte_2_1","cssClass":"custom-hotspot Ruimte_2_1","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_2_1","afterCompletion":{"create":"Ruimte_2_2","hide":true},"startingAction":15},"pitch":90,"yaw":90,"type":"info","text":"Naar eregalerij"}],"autoLoad":true}};
        const hotspots : {[ID : string] : Hotspot} = {"Ruimte_1_1":{"id":"Ruimte_1_1","cssClass":"custom-hotspot Ruimte_1_1","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_1","afterCompletion":{"create":"Ruimte_1_2","view":"Ruimte_1_2","hide":true},"startingAction":0},"pitch":170,"yaw":170,"type":"info","text":"Werken bij Rijksmuseum"},"Ruimte_1_2":{"id":"Ruimte_1_2","cssClass":"custom-hotspot Ruimte_1_2","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_2","afterCompletion":{"hide":true},"startingAction":8},"pitch":90,"yaw":90,"type":"scene","text":"Werken bij Rijksmuseum","sceneId":"Ruimte_2"},"Ruimte_2_1":{"id":"Ruimte_2_1","cssClass":"custom-hotspot Ruimte_2_1","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_2_1","afterCompletion":{"create":"Ruimte_2_2","hide":true},"startingAction":15},"pitch":90,"yaw":90,"type":"info","text":"Naar eregalerij"},"Ruimte_2_2":{"id":"Ruimte_2_2","cssClass":"custom-hotspot Ruimte_2_2","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_2_2","afterCompletion":{}},"pitch":50,"yaw":50,"type":"scene","text":"Naar Atrium","sceneId":"Ruimte_1"}};
        const actions : (TextAction | VideoAction | QuestionAction | RedirectAction)[] = [{"type":"text","content":"<h1 id=\"hello-world\">Hello World</h1>\n<p>  This is a test</p>\n","next":1},{"type":"text","content":"<h1 id=\"does-this-work-as-intended\">Does this work as intended?</h1>\n<p>  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.    </p>\n","next":2},{"type":"text","content":"<h1 id=\"hello-world-1\">Hello World</h1>\n<p>  This is a test</p>\n","next":3},{"type":"video","vimeoId":791465856,"next":4},{"type":"question","question":"<h1 id=\"is-this-a-test\">Is this a test?</h1>\n","answers":[{"answer":"Yes","next":0},{"answer":"No","next":1},{"answer":"Open Google","next":5},{"answer":"Return to environment"}]},{"type":"redirect","url":"https://www.google.nl/"},{"type":"question","question":"<h1 id=\"is-this-a-test\">Is this a test?</h1>\n","answers":[{"answer":"Yes","next":0},{"answer":"No","next":1},{"answer":"Open Google","next":5},{"answer":"Return to environment"}]},{"type":"redirect","url":"https://google.nl/"},{"type":"text","content":"<h1 id=\"hello-world\">Hello World</h1>\n<p>  This is a test</p>\n","next":9},{"type":"text","content":"<h1 id=\"does-this-work-as-intended\">Does this work as intended?</h1>\n<p>  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n","next":10},{"type":"text","content":"<h1 id=\"hello-world-1\">Hello World</h1>\n<p>  This is a test</p>\n","next":11},{"type":"video","vimeoId":791465856,"next":12},{"type":"question","question":"<h1 id=\"is-this-a-test\">Is this a test?</h1>\n","answers":[{"answer":"Yes","next":8},{"answer":"No","next":9},{"answer":"Open Google","next":13},{"answer":"Return to environment"}]},{"type":"redirect","url":"https://www.google.nl/"},{"type":"question","question":"<h1 id=\"is-this-a-test\">Is this a test?</h1>\n","answers":[{"answer":"Yes","next":8},{"answer":"No","next":9},{"answer":"Open Google","next":13},{"answer":"Return to environment"}]},{"type":"text","content":"<h1 id=\"hello-world\">Hello World</h1>\n<p>  This is a test</p>\n","next":16},{"type":"video","vimeoId":791465856,"next":17},{"type":"question","question":"<h1 id=\"is-this-a-test\">Is this a test?</h1>\n","answers":[{"answer":"Yes","next":20},{"answer":"No","next":21},{"answer":"Open Google","next":18},{"answer":"Return to environment"}]},{"type":"redirect","url":"https://www.google.nl/"},{"type":"question","question":"<h1 id=\"is-this-a-test\">Is this a test?</h1>\n","answers":[{"answer":"Yes","next":20},{"answer":"No","next":21},{"answer":"Open Google","next":18},{"answer":"Return to environment"}]},{"type":"text","content":"<h1 id=\"hello-world-1\">Hello World</h1>\n<p>  This is a test</p>\n","next":21},{"type":"text","content":"<h1 id=\"does-this-work-as-intended\">Does this work as intended?</h1>\n<p>  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n","next":22},{"type":"text","content":"<h1 id=\"hello-world-2\">Hello World</h1>\n<p>  This is a test</p>\n","next":23},{"type":"redirect","url":"#is-this-a-test"}];
let viewer = pannellum.viewer('panorama', {
  default: {
    firstScene: startingScene,
  },
  scenes: scenes,
});

// This function is called when the hotspot is clicked. It handles four things, the startingAction, and the view, create and hide options.
function hotspotClickHandler(
  clickEvent: PointerEvent,
  hotspotArguments: Hotspot['clickHandlerArgs'],
) {
  // Create a new bootstrap modal.
  let modal = new bootstrap.Modal('#actionModal');
  // Check if the hotspot has a startingAction.
  if (hotspotArguments['startingAction'] != undefined) {
    if (hotspotArguments['startingAction']['type'] != 'redirect') {
      modalParser(actions[hotspotArguments['startingAction']]);
      modal.toggle();
    } else {
      // Open in a new tab:
      window.open(hotspotArguments['startingAction']['url'], '_blank');
    }
  }
  // In this order, check the arguments['afterCompletion'] for a create, hide and view value.
  // Then add an event listener that runs once to the modal, if the modal is hidden, run the afterCompletion functions.
  if (hotspotArguments['afterCompletion']['create'] != undefined) {
    // Get the element that holds the action modal.
    let actionModal = document.getElementById('actionModal');
    actionModal.addEventListener(
      'hidden.bs.modal',
      function () {
        viewer.addHotSpot(
          hotspots[hotspotArguments['afterCompletion']['create']],
        );
      },
      { once: true },
    );
  }
  if (hotspotArguments['afterCompletion']['hide'] != undefined) {
    let actionModal = document.getElementById('actionModal');
    actionModal.addEventListener(
      'hidden.bs.modal',
      function () {
        // Remove the hotspot.
        viewer.removeHotSpot(hotspotArguments.id);
      },
      { once: true },
    );
  }
  if (hotspotArguments['afterCompletion']['view'] != undefined) {
    let hotspotToView = hotspots[hotspotArguments['afterCompletion']['view']];
    let actionModal = document.getElementById('actionModal');
    actionModal.addEventListener(
      'hidden.bs.modal',
      function () {
        // Change the scene.
        viewer.lookAt(hotspotToView.pitch, hotspotToView.yaw);
      },
      { once: true },
    );
  }
}

// This function receives the action object and modifies the modal content.
function modalParser(
  action: TextAction | VideoAction | QuestionAction | RedirectAction,
) {
  let actionModal = document.getElementById('actionModal');
  // Get the #actionModal// If the action object is a Redirect, open the url in a new tab, hide the modal and stop executing the function.
  if (action['type'] == 'redirect') {
    window.open(action['url'], '_blank');
    var modal = bootstrap.Modal.getInstance(actionModal);
    modal.hide();
    return;
  }
  let modalBody = actionModal.querySelector('.modal-body');
  let modalDialog = actionModal.querySelector('.modal-dialog');
  modalBody.innerHTML = '';
  modalBody.classList.remove('video-div', 'modal-lg', 'modal-xl');
  let icon = document.createElement('i');
  icon.classList.add('bi', 'bi-arrow-right-short');
  // We check for the type of the action object.
  switch (action['type']) {
    // If the action object is a text, create a new div with the class text-wrapper and add it to the modal-body.
    case 'text':
      // Add the 'modal-lg' class to the modal-dialog.
      modalDialog.classList.add('modal-lg');
      let textWrapper = document.createElement('div');
      textWrapper.classList.add('text-wrapper');
      modalBody.appendChild(textWrapper);
      // Insert the content of the action object into the textWrapper.
      textWrapper.innerHTML = action['content'];
      // Check if there is an img in the action object.
      if (action['img'] != undefined) {
        // Create a new img element and add it to the textWrapper.
        let img = document.createElement('img');
        img.src = action['img'];
        textWrapper.appendChild(img);
      }
      // Add a button to the modal-body.
      let button = document.createElement('button');
      button.classList.add('btn', 'btn-primary');
      button.innerHTML = 'Volgende';
      button.appendChild(icon);
      actionModal.querySelector('.modal-body').appendChild(button);
      // Check if the action object has a next property.
      if (action['next'] == undefined) {
        // If the action object doesn't have a next property, add the dismiss attribute to the button.
        button.dataset.bsDismiss = 'modal';
      } else {
        // Add an event listener to the button, which only runs once.
        button.addEventListener(
          'click',
          (event) => {
            modalParser(actions[action['next']]);
          },
          { once: true },
        );
      }
      break;
    case 'video':
      // Adding appropriate classes for styling.
      modalDialog.classList.add('modal-xl');
      modalBody.classList.add('video-div');
      // Create a button and add it to the modal-body.
      let closeButton = document.createElement('button');
      closeButton.classList.add('btn-close', 'btn-close-white');
      closeButton.dataset.ariaLabel = 'Close';
      // Add a right-arrow icon to the button.
      modalBody.appendChild(closeButton);
      // Create a div with the class video-wrapper and add it to the modal-body.
      let videoWrapper = document.createElement('div');
      videoWrapper.classList.add('video-wrapper');
      modalBody.appendChild(videoWrapper);
      // Create an iframe and add it to the videoWrapper.
      let iframe = document.createElement('iframe');
      // Set the appropriate attributes for the iframe.
      iframe.src = `https://player.vimeo.com/video/${action['vimeoId']}?title=0&amp;byline=0&amp;portrait=0&amp;autoplay=1&amp;dnt=1`;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      videoWrapper.appendChild(iframe);
      // Check if the action object has a next property.
      if (action['next'] == undefined) {
        // If the action object doesn't have a next property, add the dismiss attribute to the button.
        closeButton.dataset.bsDismiss = 'modal';
      } else {
        // Add an event listener to the button, which only runs once.
        closeButton.addEventListener(
          'click',
          (event) => {
            modalParser(actions[action['next']]);
          },
          { once: true },
        );
      }
      break;
    case 'question':
      modalDialog.classList.add('modal-lg');
      // Create a new div with class 'question-wrapper' and add it to the modal-body.
      let questionWrapper = document.createElement('div');
      questionWrapper.classList.add('question-wrapper');
      modalBody.appendChild(questionWrapper);
      // Insert the content of the question into the questionWrapper.
      questionWrapper.innerHTML = action['question'];
      // Create a new form and add it to the questionWrapper.
      let form = document.createElement('form');
      // Add a div with class 'd-grid gap-2' to the form.
      let dGrid = document.createElement('div');
      dGrid.classList.add('d-grid', 'gap-2');
      form.appendChild(dGrid);
      questionWrapper.appendChild(form);
      // Loop over the answers and create a new button for each answer.
      action['answers'].forEach((answer, index) => {
        // Create the input.
        let input: HTMLInputElement = document.createElement('input');
        input.type = 'radio';
        // If the answer has a next value, add the value to the input, else set it to no-next.
        if (answer['next'] != undefined) {
          input.value = answer['next'].toString();
        } else {
          input.value = 'no-next';
        }
        input.name = 'answer';
        input.classList.add('btn-check', 'form-button');
        input.id = `opt-${index}`;
        input.autocomplete = 'off';
        // Create the label.
        let label = document.createElement('label');
        label.classList.add('btn', 'btn-outline-primary');
        label.htmlFor = `opt-${index}`;
        // Create the icons.
        let icon = document.createElement('i');
        let icon2 = document.createElement('i');
        icon.classList.add('bi', 'bi-arrow-right-short');
        icon2.classList.add('bi', 'bi-check');
        // Create the span.
        let span = document.createElement('span');
        span.innerHTML = answer['answer'];
        // Append the icon and span to the label.
        label.appendChild(icon);
        label.appendChild(icon2);
        label.appendChild(span);
        // Append the input and label to the dGrid.
        dGrid.appendChild(input);
        dGrid.appendChild(label);
      });
      // Create a button and add it to the form.
      let submitButton = document.createElement('button');
      submitButton.classList.add('btn', 'btn-primary');
      submitButton.type = 'submit';
      submitButton.innerHTML = 'Verder';
      // Add a right-arrow icon to the button.
      submitButton.appendChild(icon);
      form.appendChild(submitButton);
      // Add an event listener to the form.
      form.addEventListener('submit', (event) => {
        // Prevent the default action of the form.
        event.preventDefault();
        // Get the value of the checked radio button.
        let checked: HTMLInputElement = document.querySelector(
          'input[name="answer"]:checked',
        );
        // Check if the checked radio button has a value.
        if (checked.value == 'no-next') {
          let modal = bootstrap.Modal.getInstance(actionModal);
          // If the checked radio button doesn't have a value, close the modal.
          modal.toggle();
        } else {
          // If the checked radio button has a value, call the modalParser function with the next action.
          modalParser(actions[parseInt(checked.value)]);
        }
      });
      break;
  }
}
